/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Send_DirectlyInputs */

const en_gift_send_directly = /** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send this directly to a friend. We'll give you a secure link to share, and they can enter their own shipping details.`)
};

const es_gift_send_directly = /** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía esto directamente a un amigo. Te daremos un enlace seguro para compartir, y ellos podrán ingresar sus propios detalles de envío.`)
};

const fr_gift_send_directly = /** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyez ceci directement à un ami. Nous vous donnerons un lien sécurisé à partager, et il pourra entrer ses propres détails d'expédition.`)
};

const de_gift_send_directly = /** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sende dies direkt an einen Freund. Wir geben dir einen sicheren Link zum Teilen, und sie können ihre eigenen Lieferdetails eingeben.`)
};

const id_gift_send_directly = /** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim ini langsung ke teman. Kami akan memberi Anda tautan aman untuk dibagikan, dan mereka dapat memasukkan detail pengiriman mereka sendiri.`)
};

/** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */
const ja_gift_send_directly = en_gift_send_directly;

/** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */
const zh_gift_send_directly = en_gift_send_directly;

/** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */
const ar_gift_send_directly = en_gift_send_directly;

/** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */
const it_gift_send_directly = en_gift_send_directly;

/** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */
const ru_gift_send_directly = en_gift_send_directly;

/** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */
const pt_gift_send_directly = en_gift_send_directly;

/** @type {(inputs: Gift_Send_DirectlyInputs) => LocalizedString} */
const ko_gift_send_directly = en_gift_send_directly;

/**
* | output |
* | --- |
* | "Send this directly to a friend. We'll give you a secure link to share, and they can enter their own shipping details." |
*
* @param {Gift_Send_DirectlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_send_directly = /** @type {((inputs?: Gift_Send_DirectlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Send_DirectlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_send_directly(inputs)
	if (locale === "es") return es_gift_send_directly(inputs)
	if (locale === "fr") return fr_gift_send_directly(inputs)
	if (locale === "de") return de_gift_send_directly(inputs)
	if (locale === "ja") return ja_gift_send_directly(inputs)
	if (locale === "zh") return zh_gift_send_directly(inputs)
	if (locale === "ar") return ar_gift_send_directly(inputs)
	if (locale === "id") return id_gift_send_directly(inputs)
	if (locale === "it") return it_gift_send_directly(inputs)
	if (locale === "ru") return ru_gift_send_directly(inputs)
	if (locale === "pt") return pt_gift_send_directly(inputs)
	return ko_gift_send_directly(inputs)
});